import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Board from 'src/app/model/product/board/board';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { IP_BOARD_PART_TYPE_CHOICES } from 'src/app/model/product/ip-board/ip-board-part-type';
import Product from 'src/app/model/product/product';
import { ProductTypes } from 'src/app/model/product/product-type';
import {
  CLIENT_WINDOW_STICKER_TYPE,
  ClientWindowSticker,
} from 'src/app/model/product/windowsticker/client-windowsticker';
import { isStandardStickerPart } from 'src/app/model/product/windowsticker/standard-sticker-part';
import { isStickerPart } from 'src/app/model/product/windowsticker/sticker-part';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';

export class ClientBaseProjectPriceSummaryHelper {
  private constructor() {}

  static atLeastOneNonStandardPrice(
    products: Product[],
    projectPlacement: ProjectPlacement
  ): boolean {
    if (!CollectionHelper.isPopulated(products)) {
      return false;
    }

    if (this.projectPlacementNonStandardPrice(projectPlacement)) {
      return true;
    }

    for (const product of products) {
      switch (product.type) {
        case CLIENT_WINDOW_STICKER_TYPE:
          if (
            this.windowStickerNonStandardPrice(<ClientWindowSticker>product)
          ) {
            return true;
          }
          break;
        case ProductTypes.CUSTOMWINDOWSTICKER.value:
          return true;
        case ProductTypes.BOARD.value:
          if (this.boardNonStandardPrice(<Board>product)) {
            return true;
          }
          break;
        case ProductTypes.IP_BOARD.value:
          if (this.ipBoardNonStandardPrice(<IPBoard>product)) {
            return true;
          }
          break;
        case ProductTypes.OTHER_PRODUCT.value:
          return true;
      }
    }

    return false;
  }

  private static windowStickerNonStandardPrice(
    windowSticker: ClientWindowSticker
  ): boolean {
    if (!CollectionHelper.isPopulated(windowSticker.clientStickerParts)) {
      return false;
    }

    let standardStickerPartCount = 0;
    for (const part of windowSticker.clientStickerParts) {
      if (part.instance == null) {
        continue;
      }

      if (isStandardStickerPart(part.instance)) {
        standardStickerPartCount += 1;
        if (standardStickerPartCount > 1) {
          return true;
        }
      } else if (isStickerPart(part.instance)) {
        return true;
      }
    }

    return false;
  }

  private static boardNonStandardPrice(board: Board): boolean {
    return (
      CollectionHelper.isPopulated(board.boardParts) &&
      board.boardParts.some((bp) => bp.signSize == null)
    );
  }

  private static ipBoardNonStandardPrice(ipBoard: IPBoard): boolean {
    return (
      ipBoard.boardPart == null ||
      (ipBoard.boardPart.sign == null &&
        (ipBoard.boardPart.otherIPBoardPartType == null ||
          ipBoard.boardPart.otherIPBoardPartType.ordinal !==
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal)) ||
      (ipBoard.boardPart.titleAdjustment == null &&
        !StringHelper.isEmpty(ipBoard.boardPart.otherTitle)) ||
      (ipBoard.boardPart.otherTitleAdjustment == null &&
        !StringHelper.isEmpty(ipBoard.boardPart.otherSideOtherTitle)) ||
      (ipBoard.boardPart.phoneNumberAdjustment == null &&
        !StringHelper.isEmpty(ipBoard.boardPart.otherPhoneNumber)) ||
      (ipBoard.boardPart.otherPhoneNumberAdjustment == null &&
        !StringHelper.isEmpty(ipBoard.boardPart.otherSideOtherPhoneNumber))
    );
  }

  private static projectPlacementNonStandardPrice(
    projectPlacement: ProjectPlacement
  ): boolean {
    return (
      projectPlacement != null &&
      ((projectPlacement.secondBoard != null &&
        projectPlacement.secondBoard.secondBoardCopy === false) ||
        !StringHelper.isEmpty(projectPlacement.otherOrderPlacementInfo))
    );
  }
}
